export const WEBINAR = 'webinar';
export const DIY_EMBEDDED = 'DIY_Embedded';
export const DIY = 'diy';
export const broadcastTypes = new Set([WEBINAR, DIY_EMBEDDED, DIY]);
